import { render, staticRenderFns } from "./disbursementv2.vue?vue&type=template&id=8e8c1ce0&"
import script from "./disbursementv2.vue?vue&type=script&lang=js&"
export * from "./disbursementv2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports